import http from "../http";
export default {
  getChatInfo(params) {
    return http.get("/work_order/chat/getChatInfo", { params });
  },
  getUserInfo(params) {
    return http.get("/work_order/chat/getUserInfo", { params });
  },
};
